window._ = require("lodash");
import * as isLeapYear from "dayjs/plugin/isLeapYear"; // import plugin
import "dayjs/locale/pt"; // import locale

try {
    require("bootstrap");

    window.bootstrap = require("bootstrap"); //powergrid !!!!
    window.dayjs = require("dayjs");
    window.dayjs.extend(isLeapYear); // use plugin
    window.dayjs.locale("pt"); // use locale
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require("axios");

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });

/*
import Swup from "swup";
import SwupLivewirePlugin from "@swup/livewire-plugin";

const swup = new Swup({
    plugins: [new SwupLivewirePlugin()],
});
*/
